<template>
  <div class="law_question">
    <div class="qt_content between">
      <div class="qtc_l">
        <div class="qtc_title flex_start">
          <div :class="{ qtc_active: status == 0 }" @click="clitab(0)">
            最新咨询
          </div>
          <div :class="{ qtc_active: status == 1 }" @click="clitab(1)">
            已解决问题
          </div>
        </div>
        <div class="qtc_list">
          <div class="qtc_item" v-for="item in 7" :key="item">
            <div class="li_title ellipsis">
              <span class="ask"
                ><img src="../../../assets/question/w.png"
              /></span>
              强制执行阶段，被告的财产评估费是由原告支付吗强制执行阶段，被告的财产评估费是由原告支付吗强制执行阶段，被告的财产评估费是由原告支付吗
            </div>
            <div class="li_bt flex_start">
              <div class="li_tag" v-for="tag_item in 1" :key="tag_item">
                公司法
              </div>
              <div class="li_time center">
                <img src="../../../assets/question/shijian.png" />
                5分钟前
              </div>
              <div class="li_adres center">
                <img src="../../../assets/question/dingwei.png" />
                安徽-阜阳
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="qtc_r">
        <div class="qtcr_list">
          <div
            class="qtcr_item"
            v-for="(item, index) in 4"
            :key="index"
            :class="{ qtcr_item2: index % 2 == 1 }"
          >
            <div class="ti">蒋俊律师</div>
            <div class="de">刑事辩护、交通事故</div>
            <div class="pho flex_start">
              <svg-icon icon-class="dianhua" class="svgbg" /> 1776588112
            </div>
            <div class="online text_hover_shou">在线咨询</div>
            <div class="figure">
              <img src="../../../assets/question/figure.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
	
    <div class="qt_ify between">
		<!-- 热点法律咨询 -->
		<div class="con-hot">
			<div class="qti_title"><sub-title text="热点法律咨询" /></div>
			<ul class="hotlist">
				<li  
				class="FontSize14 FontBlack hotitem"
				v-for="(item,index) in 6">
				分遗产夫妻共同财产，96福利分房产是分遗产夫妻共同财产，96福利分房产是分遗产夫妻共同财共同财...</li>
			</ul>
		</div>
		
      <div class="qti_l">
        <div class="qti_title"><sub-title text="问题分类" /></div>
        <div class="qti_tag between wrap text_center">
		  <div 
		  :class="['plan_tag_item', 'flex-col', 'center', 'FontGray', 'FontSize14', ]"
		   v-for="(item,index) in solutioncats" 
		  @click="tosolution(item.id)"
		  >
		  <svg-icon :icon-class="`homesutn_${index+1}`" style="width: 22px;height: 22px;"></svg-icon>
		  <span>{{item.cat_name}}</span>
			<!-- <home-icon :iconSrc="`homesutn_${index+1}`" :iconText="item.cat_name" /> -->
		  </div>
        </div>
      </div>
      <!-- <div class="qti_r">
        <div class="qti_r_ti flex">
          <div :class="{ act: rank_status == 0 }" @click="clitab2(0)">
            律师解答榜
          </div>
          <div :class="{ act: rank_status == 1 }" @click="clitab2(1)">
            律师采纳榜
          </div>
        </div>
        <ranking-ling
          :showTitle="false"
          style="width: 360px; padding: 28px 17px"
        ></ranking-ling>
      </div> -->
    </div>
	
    <div class="qt_adv between text_center">
      <lay-item-win
        style="width: 222px; height: 314px"
        v-for="(item, index) in laywerlist"
        :key="index"
		:item = 'item'
        :consult-or-more="true"
      ></lay-item-win>
    </div>
  </div>
</template>

<script>
import homeIcon from "../../home/components/homeIcon.vue";
import rankingLing from "views/home/components/rankingLing";
import layItemWin from "views/home/components/layItemWin";
import subTitle from "views/home/components/subTitle";
export default {
  components: {
    homeIcon,
    rankingLing,
    layItemWin,
    subTitle,
  },
  data: () => ({
    status: 0,
    rank_status: 0,
	solutioncats:[],
	laywerlist:[]
  }),
  created() {
  	this.$http.home.solutioncats().then( res => {
  		this.solutioncats = res.data
  	})
	this.$http.home.lawyerads({
		ad_id:14,
		limit:4
	}).then( res => {
		this.laywerlist = res.data.data
	})
  },
  methods: {
    clitab(index) {
      this.status = index;
    },
    clitab2(index) {
      this.rank_status = index;
    },
  },
};
</script>
 <style lang="scss" scope>
.law_question {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0;
  .qt_content {
    align-items: start;
    margin-bottom: 30px;
    .qtc_l {
      width: 810px;
      background-color: #fff;
      .qtc_title {
        font-size: 18px;
        color: #333;
        height: 60px;
        line-height: 60px;
        background: #ffffff;
        border: 1px solid #f5f5f5;
        .qtc_active {
          height: 60px;
          border-bottom: 2px solid #0465ea;
        }
        div {
          cursor: pointer;
          padding: 0 9px;
          margin-left: 32px;
        }
      }
      .qtc_list {
        padding: 0 27px;
        .qtc_item {
          padding: 28px 0;
          border-bottom: 1px solid #eee;
          &:hover {
            .li_title {
              color: #0465ea;
            }
          }
          .li_title {
            color: #333;
            .ask {
              img {
                width: 26px;
                height: 26px;
                margin-right: 16px;
              }
            }
          }
          .li_bt {
            margin-top: 20px;

            > div {
              margin-right: 14px;
              color: #333;
              font-size: 12px;
            }
            img {
              margin-right: 6px;
            }
            .li_tag {
              padding: 3px 10px;
              background: #f7f7f7;
              border-radius: 5px;
              color: #666;
            }
          }
        }
      }
    }
    .qtc_r {
      width: 360px;
      height: 935px;
      .qtcr_list {
        .qtcr_item {
          margin-bottom: 26px;
          width: 100%;
          height: 214px;
          padding: 44px 40px 0;
          position: relative;
          background-image: url("../../../assets/question/quest_ad_bg0.png");
          .ti {
            font-weight: 600;
            font-size: 20px;
          }
          .de {
            font-size: 16px;
            margin: 10px 0;
          }
          .pho {
            .svgbg {
              color: #ff882a;
            }
          }
          .online {
            font-size: 14px;
            display: inline-block;
            padding: 2px 8px;
            color: #ff3000;
            margin-top: 8px;
            border: 1px solid #ff3000;
            border-radius: 20px;
          }
          .figure {
            position: absolute;
            bottom: 0;
            right: 10px;
          }
        }
        .qtcr_item2 {
          background-image: url("../../../assets/question/quest_ad_bg1.png");
          .pho {
            .svgbg {
              color: #6aaaf4;
            }
          }
        }
      }
    }
  }
  .qt_ify {
    align-items: start;
	.con-hot{
		padding: 24px 20px;
		width: 810px;
		background-color: #ffffff;
		background-image: url(../../../assets/question/bg1.png);
		background-position: right;
		background-size: contain;
		background-repeat: no-repeat;
		.hotlist{
			.hotitem{
				margin-top: 24px;
				padding-left: 15px;
				position: relative;
				cursor: pointer;
			}
			
		}
	}
	.hotitem::before{
		content: '';
		position: absolute;
		top: 8px;
		left: 0px;
		width: 6px;
		height: 6px;
		background-color: #e6e6e6;
		border-radius: 50%;
	}
    .qti_l {
      width: 360px;
      background-color: #fff;
      padding: 25px 20px;
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
      border-radius: 2px;
      .qti_tag {
        width: 100%;
		margin-top: 20px;
        .plan_tag_item {
        		  width: 25%;
        		  height: 80px;
				  cursor: pointer;
        }
		.plan_tag_item:hover{
			color: #0465EA;
		}
      }
    }
    .qti_r {
      width: 360px;
      background-color: #fff;
      .qti_r_ti {
        color: #333;
        > div {
          flex: 1;
          padding: 10px 0;
          border-bottom: 2px solid #0465ea;
          text-align: center;
        }
        .act {
          color: #fff;
          background-color: #0465ea;
        }
      }
    }
  }
  .qt_adv {
    margin-top: 30px;
  }
}
</style>